var React = require('react');

function DismissInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.26166 4.27729C4.55456 3.98439 5.02943 3.98439 5.32232 4.27729L14.0001 12.9551L22.6779 4.27729C22.9708 3.98439 23.4457 3.98439 23.7386 4.27729C24.0315 4.57018 24.0315 5.04505 23.7386 5.33795L15.0608 14.0158L23.7063 22.6612C23.9992 22.9541 23.9992 23.429 23.7063 23.7219C23.4134 24.0148 22.9385 24.0148 22.6456 23.7219L14.0001 15.0764L5.35466 23.7219C5.06177 24.0148 4.58689 24.0148 4.294 23.7219C4.00111 23.429 4.00111 22.9541 4.294 22.6612L12.9395 14.0158L4.26166 5.33795C3.96877 5.04505 3.96877 4.57018 4.26166 4.27729Z","fill":"#262626"}));
}

DismissInline.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = DismissInline;

DismissInline.default = DismissInline;
